// AUTO-GENERATED by tools/gen-progress-registry.mjs from data/game-catalogue.json
// and games/*/levels/levels.config.json. Do not edit by hand: re-run
// `node tools/gen-progress-registry.mjs`.
//
// The portal's copy of the app's skill registry (design §4.1), so the Timeline
// and One-Pager name the same skills and steps the family's Skill Garden does.

/** English always; any other language is a draft behind native review. */
export type LocalizedText = { en: string } & { [lang: string]: string | null | undefined };

export interface SkillStepDef {
  n: number;
  text: LocalizedText;
  levels: number[];
}

export interface SkillDef {
  id: string;
  domain: string;
  ageMin: number;
  label: LocalizedText;
  games: string[];
  steps: SkillStepDef[];
}

export interface BuiltGame {
  id: string;
  name: LocalizedText;
  domain: string;
  skillId: string;
  ageMin: number;
  /** Free in the app (gating.ts FREE_CHARACTERS); false = needs Premium. */
  free: boolean;
}

export const STEP_COUNT = 4;

export const SKILLS: SkillDef[] = [
  {
    "id": "receptive_language",
    "domain": "language",
    "ageMin": 3,
    "label": {
      "en": "Listening and Following Instructions",
      "ms": "Mendengar dan mengikut arahan"
    },
    "games": [
      "elephant-says-listen"
    ],
    "steps": [
      {
        "n": 1,
        "text": {
          "en": "Names familiar objects like ball, cup, banana or cat when heard.",
          "ms": "Mengenal pasti objek biasa seperti bola, cawan, pisang atau kucing apabila disebut."
        },
        "levels": [
          1,
          2,
          3
        ]
      },
      {
        "n": 2,
        "text": {
          "en": "Understands big and little.",
          "ms": "Memahami besar dan kecil."
        },
        "levels": [
          4,
          5,
          6
        ]
      },
      {
        "n": 3,
        "text": {
          "en": "Understands in, on and under.",
          "ms": "Memahami di dalam, di atas dan di bawah."
        },
        "levels": [
          7,
          8
        ]
      },
      {
        "n": 4,
        "text": {
          "en": "Beginning to follow a 2-step instruction with two unrelated items.",
          "ms": "Mula mengikut arahan 2 langkah dengan dua barang yang tidak berkaitan."
        },
        "levels": [
          9,
          10
        ]
      }
    ]
  },
  {
    "id": "vocabulary",
    "domain": "language",
    "ageMin": 3,
    "label": {
      "en": "Vocabulary Building",
      "ms": "Membina perbendaharaan kata"
    },
    "games": [
      "parrots-word-zoo"
    ],
    "steps": [
      {
        "n": 1,
        "text": {
          "en": "Takes a turn to say familiar words with the parrot, or taps the picture to hear the word said.",
          "ms": "Bergilir menyebut perkataan biasa bersama burung nuri, atau mengetik gambar untuk mendengar perkataan itu."
        },
        "levels": [
          1,
          2,
          3
        ]
      },
      {
        "n": 2,
        "text": {
          "en": "Puts things that belong together into one family, like food or animals.",
          "ms": "Mengumpulkan benda yang sejenis dalam satu kumpulan, seperti makanan atau haiwan."
        },
        "levels": [
          4,
          5,
          6
        ]
      },
      {
        "n": 3,
        "text": {
          "en": "Chooses which word to say, and takes a turn with the parrot.",
          "ms": "Memilih perkataan yang hendak disebut, dan bergilir bersama burung nuri."
        },
        "levels": [
          7,
          8
        ]
      },
      {
        "n": 4,
        "text": {
          "en": "Is meeting new words in short sentences that explain them.",
          "ms": "Sedang mengenal perkataan baharu dalam ayat pendek yang menerangkannya."
        },
        "levels": [
          9,
          10
        ]
      }
    ]
  },
  {
    "id": "sorting_matching",
    "domain": "executive_function",
    "ageMin": 3,
    "label": {
      "en": "Matching and Sorting",
      "ms": "Memadan dan mengisih"
    },
    "games": [
      "monkeys-sort-yard"
    ],
    "steps": [
      {
        "n": 1,
        "text": {
          "en": "Puts one object into the matching colour basket when shown where it goes.",
          "ms": "Memasukkan satu objek ke dalam bakul warna yang sepadan apabila ditunjukkan tempatnya."
        },
        "levels": [
          1,
          2,
          3
        ]
      },
      {
        "n": 2,
        "text": {
          "en": "Sorts the same object into big and small baskets.",
          "ms": "Mengisih objek yang sama ke dalam bakul besar dan bakul kecil."
        },
        "levels": [
          4,
          5
        ]
      },
      {
        "n": 3,
        "text": {
          "en": "Puts food with food and animals with animals.",
          "ms": "Meletakkan makanan bersama makanan dan haiwan bersama haiwan."
        },
        "levels": [
          6,
          7
        ]
      },
      {
        "n": 4,
        "text": {
          "en": "Works out the colour rule from what is already in the baskets.",
          "ms": "Memahami peraturan warna daripada apa yang sudah ada dalam bakul."
        },
        "levels": [
          8,
          9,
          10
        ]
      }
    ]
  },
  {
    "id": "emotional_recognition",
    "domain": "social_emotional",
    "ageMin": 3,
    "label": {
      "en": "Emotional Recognition",
      "ms": "Mengenal perasaan"
    },
    "games": [
      "turtles-feeling-corner"
    ],
    "steps": [
      {
        "n": 1,
        "text": {
          "en": "Finds happy and sad when they are named.",
          "ms": "Menemui gembira dan sedih apabila disebut."
        },
        "levels": [
          1,
          2,
          3
        ]
      },
      {
        "n": 2,
        "text": {
          "en": "Has met surprised, calm and proud — exploring new feelings.",
          "ms": "Sudah mengenal terkejut, tenang dan bangga — sedang meneroka perasaan baharu."
        },
        "levels": [
          4,
          5,
          6
        ]
      },
      {
        "n": 3,
        "text": {
          "en": "Explores more than one feeling that can fit a moment (exploring).",
          "ms": "Meneroka lebih daripada satu perasaan yang sesuai dengan sesuatu ketika (meneroka)."
        },
        "levels": [
          7,
          8,
          9
        ]
      },
      {
        "n": 4,
        "text": {
          "en": "Knows a calming idea exists (exploring).",
          "ms": "Tahu ada cara untuk menenangkan diri (meneroka)."
        },
        "levels": [
          10,
          11,
          12
        ]
      }
    ]
  },
  {
    "id": "counting_cardinality",
    "domain": "numeracy",
    "ageMin": 3,
    "label": {
      "en": "Numeracy — Counting",
      "ms": "Mengira"
    },
    "games": [
      "penguins-count-pool"
    ],
    "steps": [
      {
        "n": 1,
        "text": {
          "en": "Counts 1–3 with one-to-one touch · says how many to 3",
          "ms": "Mengira 1–3 dengan menyentuh satu demi satu · menyebut berapa banyak hingga 3"
        },
        "levels": [
          1,
          2,
          3
        ]
      },
      {
        "n": 2,
        "text": {
          "en": "Counts to 10 · cardinality to 10 · ten-frame fluency",
          "ms": "Mengira hingga 10 · tahu jumlahnya hingga 10 · lancar dengan bingkai sepuluh"
        },
        "levels": [
          4,
          5
        ]
      },
      {
        "n": 3,
        "text": {
          "en": "Makes a set of up to 10 on request",
          "ms": "Membuat set hingga 10 apabila diminta"
        },
        "levels": [
          6,
          7
        ]
      },
      {
        "n": 4,
        "text": {
          "en": "Conservation of number holds to 10",
          "ms": "Tahu bilangan kekal sama hingga 10 walaupun susunannya berubah"
        },
        "levels": [
          8,
          9,
          10
        ]
      }
    ]
  },
  {
    "id": "colour_matching",
    "domain": "perception",
    "ageMin": 3,
    "label": {
      "en": "Shapes, Colours and Patterns",
      "ms": "Bentuk, warna dan corak"
    },
    "games": [
      "zebras-color-stripes"
    ],
    "steps": [
      {
        "n": 1,
        "text": {
          "en": "Matched red and blue to the same colour - without needing the words yet.",
          "ms": "Memadankan merah dan biru dengan warna yang sama - tanpa perlu tahu namanya lagi."
        },
        "levels": [
          1,
          2,
          3
        ]
      },
      {
        "n": 2,
        "text": {
          "en": "Found red, blue, yellow and green when Zebra named them.",
          "ms": "Menemui merah, biru, kuning dan hijau apabila Zebra menyebutnya."
        },
        "levels": [
          4,
          5,
          6
        ]
      },
      {
        "n": 3,
        "text": {
          "en": "Put stripes into two colour baskets.",
          "ms": "Memasukkan jalur ke dalam dua bakul warna."
        },
        "levels": [
          7,
          8
        ]
      },
      {
        "n": 4,
        "text": {
          "en": "Carried on Zebra's two-colour stripe pattern.",
          "ms": "Menyambung corak jalur dua warna Zebra."
        },
        "levels": [
          9,
          10
        ]
      }
    ]
  },
  {
    "id": "fine_motor_tracing",
    "domain": "motor",
    "ageMin": 3,
    "label": {
      "en": "Fine Motor Skills",
      "ms": "Kemahiran motor halus"
    },
    "games": [
      "snakes-first-path"
    ],
    "steps": [
      {
        "n": 1,
        "text": {
          "en": "Traces a straight path from the start to the goal.",
          "ms": "Menyurih laluan lurus dari mula hingga ke sasaran."
        },
        "levels": [
          1,
          2,
          3
        ]
      },
      {
        "n": 2,
        "text": {
          "en": "Traces a full circle all the way back round to where it started.",
          "ms": "Menyurih bulatan penuh hingga kembali ke tempat ia bermula."
        },
        "levels": [
          4,
          5
        ]
      },
      {
        "n": 3,
        "text": {
          "en": "Chooses between two paths and traces the one that reaches the goal.",
          "ms": "Memilih antara dua laluan dan menyurih laluan yang sampai ke sasaran."
        },
        "levels": [
          6,
          7
        ]
      },
      {
        "n": 4,
        "text": {
          "en": "Follows a dotted line or curve with less of the path drawn in.",
          "ms": "Mengikut garis atau lengkung bertitik apabila kurang bahagian laluan yang dilukis."
        },
        "levels": [
          8,
          9,
          10
        ]
      }
    ]
  },
  {
    "id": "daily_routines",
    "domain": "daily_life",
    "ageMin": 3,
    "label": {
      "en": "Daily Routines",
      "ms": "Rutin harian"
    },
    "games": [
      "koalas-morning"
    ],
    "steps": [
      {
        "n": 1,
        "text": {
          "en": "Followed Koala's three-step morning - wake up, wash face, eat - one step at a time.",
          "ms": "Mengikut rutin pagi tiga langkah Koala - bangun, basuh muka, makan - satu langkah demi satu langkah."
        },
        "levels": [
          1,
          2,
          3
        ]
      },
      {
        "n": 2,
        "text": {
          "en": "Built a two-step routine in first-then order - for example wash hands, then eat.",
          "ms": "Menyusun rutin dua langkah mengikut urutan mula-kemudian - contohnya basuh tangan, kemudian makan."
        },
        "levels": [
          4,
          5
        ]
      },
      {
        "n": 3,
        "text": {
          "en": "Chose the next step from three choices across bedtime, mealtime and school routines.",
          "ms": "Memilih langkah seterusnya daripada tiga pilihan dalam rutin waktu tidur, waktu makan dan sekolah."
        },
        "levels": [
          6,
          7
        ]
      },
      {
        "n": 4,
        "text": {
          "en": "Chose their own order for steps that can go either way - and heard that both ways are okay.",
          "ms": "Memilih urutan sendiri bagi langkah yang boleh dibuat dalam apa-apa susunan - dan mendengar bahawa kedua-duanya betul."
        },
        "levels": [
          8,
          9,
          10
        ]
      }
    ]
  },
  {
    "id": "multi_step_instructions",
    "domain": "language",
    "ageMin": 4,
    "label": {
      "en": "Listening and Instructions",
      "ms": "Mendengar dan arahan"
    },
    "games": [
      "elephants-3-step-task"
    ],
    "steps": [
      {
        "n": 1,
        "text": {
          "en": "Brought the object the elephant asked for, choosing from three on the mat.",
          "ms": "Membawa objek yang diminta gajah, memilih daripada tiga di atas tikar."
        },
        "levels": [
          1,
          2,
          3
        ]
      },
      {
        "n": 2,
        "text": {
          "en": "Held three things at once: which object, which size, and which place.",
          "ms": "Mengingat tiga perkara serentak: objek yang mana, saiz yang mana, dan tempat yang mana."
        },
        "levels": [
          4,
          5
        ]
      },
      {
        "n": 3,
        "text": {
          "en": "Followed a two-step instruction that used the words first and then.",
          "ms": "Mengikut arahan dua langkah yang menggunakan perkataan dahulu dan kemudian."
        },
        "levels": [
          6,
          7
        ]
      },
      {
        "n": 4,
        "text": {
          "en": "Did three things in the order the elephant asked for them.",
          "ms": "Melakukan tiga perkara mengikut susunan yang diminta gajah."
        },
        "levels": [
          8,
          9,
          10
        ]
      }
    ]
  },
  {
    "id": "phonological_awareness",
    "domain": "literacy",
    "ageMin": 4,
    "label": {
      "en": "Rhyme and Sound Awareness",
      "ms": "Rima dan kesedaran bunyi"
    },
    "games": [
      "parrots-rhyme-race"
    ],
    "steps": [
      {
        "n": 1,
        "text": {
          "en": "Tapped out two beats in familiar words.",
          "ms": "Mengetuk dua bunyi dalam perkataan biasa."
        },
        "levels": [
          1,
          2,
          3
        ]
      },
      {
        "n": 2,
        "text": {
          "en": "Chose the rhyming word from three pictures.",
          "ms": "Memilih perkataan berima daripada tiga gambar."
        },
        "levels": [
          4,
          5
        ]
      },
      {
        "n": 3,
        "text": {
          "en": "Offered rhyming words of their own — the parrot echoed each one back.",
          "ms": "Memberi perkataan berima sendiri — burung nuri mengulanginya."
        },
        "levels": [
          6,
          7
        ]
      },
      {
        "n": 4,
        "text": {
          "en": "Sorted four words into two nests by their ending sound.",
          "ms": "Mengasingkan empat perkataan ke dalam dua sarang mengikut bunyi hujung."
        },
        "levels": [
          8,
          9,
          10
        ]
      }
    ]
  },
  {
    "id": "safety_awareness",
    "domain": "daily_life",
    "ageMin": 4,
    "label": {
      "en": "Safety Awareness",
      "ms": "Kesedaran keselamatan"
    },
    "games": [
      "lions-safe-choices"
    ],
    "steps": [
      {
        "n": 1,
        "text": {
          "en": "Sorted toys into the toy box and hot or sharp grown-up things onto the high shelf. Try it at home: find one hot thing and one sharp thing in your kitchen together and say \"grown-ups only\".",
          "ms": "Mengasingkan mainan ke dalam kotak mainan, dan barang orang dewasa yang panas atau tajam ke rak tinggi. Cuba di rumah: cari satu barang panas dan satu barang tajam di dapur bersama-sama, dan sebut \"untuk orang dewasa sahaja\"."
        },
        "levels": [
          1,
          2,
          3
        ]
      },
      {
        "n": 2,
        "text": {
          "en": "Chose go ahead or stop outside - at a road, near water and with a dog they did not know - and did the stop, step back, tell steps themselves. Try it at home: on your next walk, stop together at a kerb and practise the three steps.",
          "ms": "Memilih teruskan atau berhenti di luar - di jalan raya, dekat air dan dengan anjing yang tidak dikenali - dan buat sendiri langkah berhenti, undur, beritahu. Cuba di rumah: semasa berjalan nanti, berhenti bersama di tepi jalan dan berlatih tiga langkah itu."
        },
        "levels": [
          4,
          5
        ]
      },
      {
        "n": 3,
        "text": {
          "en": "Picked the safety gear before going: a helmet for the bicycle and the motorbike, a seatbelt for the car, and a hat for the hot sun. Try it at home: let your child put on and click their own helmet or seatbelt before every ride.",
          "ms": "Memilih alat keselamatan sebelum pergi: topi keledar untuk basikal dan motosikal, tali pinggang keledar untuk kereta, dan topi untuk matahari panas. Cuba di rumah: biar anak anda pakai dan klik sendiri topi keledar atau tali pinggang keledar sebelum setiap perjalanan."
        },
        "levels": [
          6,
          7
        ]
      },
      {
        "n": 4,
        "text": {
          "en": "Chose a grown-up helper over a little friend: their own grown-up at home, a shop helper with a name badge, and a police officer at the park. Try it at home: point out a shop helper's name badge and a police officer next time you are out.",
          "ms": "Memilih orang dewasa yang boleh menolong, bukan kawan kecil: orang dewasa sendiri di rumah, pekerja kedai yang memakai tanda nama, dan polis di taman. Cuba di rumah: tunjukkan tanda nama pekerja kedai dan anggota polis apabila keluar nanti."
        },
        "levels": [
          8,
          9,
          10
        ]
      }
    ]
  },
  {
    "id": "visual_perception",
    "domain": "perception",
    "ageMin": 4,
    "label": {
      "en": "Looking Carefully",
      "ms": "Melihat dengan teliti"
    },
    "games": [
      "giraffes-spot-it"
    ],
    "steps": [
      {
        "n": 1,
        "text": {
          "en": "Found the picture that was the same as Giraffe's card, among three different things. Try it at home: hold up one toy and ask your child to find the same one among three on the table.",
          "ms": "Mencari gambar yang sama dengan kad Zirafah, antara tiga benda yang berlainan. Cuba di rumah: tunjukkan satu mainan dan minta anak cari yang sama antara tiga di atas meja."
        },
        "levels": [
          1,
          2,
          3
        ]
      },
      {
        "n": 2,
        "text": {
          "en": "Matched a picture to its shadow, choosing from three shadows that show only the shape. Try it at home: shine a torch on a toy against the wall and guess whose shadow it is.",
          "ms": "Memadankan gambar dengan bayangnya, memilih daripada tiga bayang yang hanya menunjukkan bentuk. Cuba di rumah: suluh lampu pada mainan ke dinding dan teka bayang siapa itu."
        },
        "levels": [
          4,
          5
        ]
      },
      {
        "n": 3,
        "text": {
          "en": "Kept looking until all three of the same thing were found among eight, putting each one in Giraffe's basket. Try it at home: tidy up together by finding every red block (or every sock) and putting them in one basket.",
          "ms": "Terus mencari sehingga ketiga-tiga benda yang sama dijumpai antara lapan, dan memasukkan setiap satu ke dalam bakul Zirafah. Cuba di rumah: kemas bersama-sama dengan mencari setiap blok merah (atau setiap stokin) dan masukkan ke dalam satu bakul."
        },
        "levels": [
          6,
          7
        ]
      },
      {
        "n": 4,
        "text": {
          "en": "Matched pictures to shadows that were turned a little and bigger or smaller than the picture. Try it at home: tilt a toy in a torch beam and watch its shadow turn - is it still the same toy?",
          "ms": "Memadankan gambar dengan bayang yang berpusing sedikit dan lebih besar atau lebih kecil daripada gambar. Cuba di rumah: condongkan mainan di bawah cahaya lampu suluh dan lihat bayangnya berpusing - masih mainan yang sama?"
        },
        "levels": [
          8,
          9,
          10
        ]
      }
    ]
  },
  {
    "id": "working_memory",
    "domain": "executive_function",
    "ageMin": 4,
    "label": {
      "en": "Memory",
      "ms": "Ingatan"
    },
    "games": [
      "monkeys-memory-match"
    ],
    "steps": [
      {
        "n": 1,
        "text": {
          "en": "Watched Monkey hide a banana and looked for it under one of three things.",
          "ms": "Melihat Monyet menyorokkan pisang dan mencarinya di bawah salah satu daripada tiga benda."
        },
        "levels": [
          1,
          2,
          3
        ]
      },
      {
        "n": 2,
        "text": {
          "en": "Looked at two pairs of cards, hid them, and found the twins.",
          "ms": "Melihat dua pasang kad, menyorokkannya, dan mencari yang kembar."
        },
        "levels": [
          4,
          5
        ]
      },
      {
        "n": 3,
        "text": {
          "en": "Watched two butterflies land in a garden of six flowers and looked for where they sat.",
          "ms": "Melihat dua rama-rama hinggap di taman enam bunga dan mencari tempat mereka hinggap."
        },
        "levels": [
          6,
          7
        ]
      },
      {
        "n": 4,
        "text": {
          "en": "Looked at a picnic of four foods and picked the one Monkey hid.",
          "ms": "Melihat empat makanan dan memilih makanan yang disorokkan Monyet."
        },
        "levels": [
          8,
          9,
          10
        ]
      }
    ]
  },
  {
    "id": "turn_taking",
    "domain": "social_emotional",
    "ageMin": 4,
    "label": {
      "en": "Turn-Taking",
      "ms": "Bergilir-gilir"
    },
    "games": [
      "penguins-turn"
    ],
    "steps": [
      {
        "n": 1,
        "text": {
          "en": "Took a turn with Penguin when the turn card came over, and finished a tower together.",
          "ms": "Mengambil giliran bersama Penguin apabila kad giliran sampai, dan menyiapkan menara bersama-sama."
        },
        "levels": [
          1,
          2,
          3
        ]
      },
      {
        "n": 2,
        "text": {
          "en": "Waited while Penguin took its turn, watched the turn card come over, then took a turn.",
          "ms": "Menunggu semasa Penguin mengambil gilirannya, melihat kad giliran sampai, kemudian mengambil giliran."
        },
        "levels": [
          4,
          5
        ]
      },
      {
        "n": 3,
        "text": {
          "en": "Asked Penguin for a turn by passing the ask card, then took the turn.",
          "ms": "Meminta giliran daripada Penguin dengan menghulurkan kad minta, kemudian mengambil giliran itu."
        },
        "levels": [
          6,
          7
        ]
      },
      {
        "n": 4,
        "text": {
          "en": "Answered Penguin's choice with a choice of their own on each turn.",
          "ms": "Membalas pilihan Penguin dengan satu pilihan baharu pada setiap giliran."
        },
        "levels": [
          8,
          9,
          10
        ]
      }
    ]
  },
  {
    "id": "pattern_recognition",
    "domain": "executive_function",
    "ageMin": 4,
    "label": {
      "en": "Patterns",
      "ms": "Corak"
    },
    "games": [
      "zebras-pattern-line"
    ],
    "steps": [
      {
        "n": 1,
        "text": {
          "en": "Copied a two-part pattern onto their train, one piece at a time.",
          "ms": "Menyalin corak dua bahagian ke kereta api mereka, satu demi satu."
        },
        "levels": [
          1,
          2,
          3
        ]
      },
      {
        "n": 2,
        "text": {
          "en": "Found the missing animal in three-part patterns where one animal comes twice.",
          "ms": "Mencari haiwan yang hilang dalam corak tiga bahagian yang ada satu haiwan muncul dua kali."
        },
        "levels": [
          4,
          5
        ]
      },
      {
        "n": 3,
        "text": {
          "en": "Played a pattern of animals as a pattern of sounds on a drum and a bell.",
          "ms": "Memainkan corak haiwan sebagai corak bunyi dengan kompang dan loceng."
        },
        "levels": [
          6,
          7
        ]
      },
      {
        "n": 4,
        "text": {
          "en": "Met a parade with one animal that did not belong, and put the right one back in its place.",
          "ms": "Menemui perarakan yang ada satu haiwan tersesat, dan meletakkan haiwan yang betul di tempatnya."
        },
        "levels": [
          8,
          9,
          10
        ]
      }
    ]
  },
  {
    "id": "letter_formation",
    "domain": "literacy",
    "ageMin": 4,
    "label": {
      "en": "Fine Motor and Early Writing",
      "ms": "Motor halus dan menulis awal"
    },
    "games": [
      "snakes-letter-path"
    ],
    "steps": [
      {
        "n": 1,
        "text": {
          "en": "Writes letters made of straight lines, one stroke at a time, working from the top down.",
          "ms": "Menulis huruf yang terdiri daripada garis lurus, satu goresan demi satu goresan, dari atas ke bawah."
        },
        "levels": [
          1,
          2,
          3
        ]
      },
      {
        "n": 2,
        "text": {
          "en": "Writes letters that join a straight line to a curve, in the right order.",
          "ms": "Menulis huruf yang menyambungkan garis lurus dengan lengkung, mengikut urutan yang betul."
        },
        "levels": [
          4,
          5
        ]
      },
      {
        "n": 3,
        "text": {
          "en": "Looks at a letter and begins it in the place a letter is meant to begin.",
          "ms": "Melihat huruf dan memulakannya di tempat huruf itu sepatutnya bermula."
        },
        "levels": [
          6,
          7
        ]
      },
      {
        "n": 4,
        "text": {
          "en": "Writes big letters with only a dotted outline left to follow.",
          "ms": "Menulis huruf besar dengan hanya garis bertitik sebagai panduan."
        },
        "levels": [
          8,
          9,
          10
        ]
      }
    ]
  },
  {
    "id": "phonics_letter_sounds",
    "domain": "literacy",
    "ageMin": 5,
    "label": {
      "en": "Phonics",
      "ms": "Fonik"
    },
    "games": [
      "parrots-sound-safari"
    ],
    "steps": [
      {
        "n": 1,
        "text": {
          "en": "Heard the “sss” sound at the start of a word and chose its picture, from two.",
          "ms": "Mendengar bunyi awal “a” dalam perkataan dan memilih gambarnya, daripada dua."
        },
        "levels": [
          1,
          2,
          3
        ]
      },
      {
        "n": 2,
        "text": {
          "en": "Looked for the things that start with “a” in a jungle picture of six things.",
          "ms": "Mencari benda yang bermula dengan suku kata “sa” dalam gambar hutan yang mengandungi enam benda."
        },
        "levels": [
          4,
          5
        ]
      },
      {
        "n": 3,
        "text": {
          "en": "Chose pictures that start with the new sound “t”, among sounds met before.",
          "ms": "Memilih gambar yang bermula dengan suku kata baharu “bu”, bersama bunyi yang telah dikenali."
        },
        "levels": [
          6,
          7
        ]
      },
      {
        "n": 4,
        "text": {
          "en": "Heard a word said slowly in two parts and found its picture.",
          "ms": "Mendengar perkataan disebut perlahan dalam dua suku kata dan menemui gambarnya."
        },
        "levels": [
          8,
          9,
          10
        ]
      }
    ]
  }
];

/** Every built game, for the practice picker. */
export const BUILT_GAMES: BuiltGame[] = [
  {
    "id": "elephant-says-listen",
    "name": {
      "en": "Elephant Says Listen",
      "ms": "Dengar Kata Gajah"
    },
    "domain": "language",
    "skillId": "receptive_language",
    "ageMin": 3,
    "free": false
  },
  {
    "id": "parrots-word-zoo",
    "name": {
      "en": "Parrot's Word Zoo",
      "ms": "Zoo Kata Nuri"
    },
    "domain": "language",
    "skillId": "vocabulary",
    "ageMin": 3,
    "free": true
  },
  {
    "id": "monkeys-sort-yard",
    "name": {
      "en": "Monkey's Sort Yard",
      "ms": "Laman Isih Monyet"
    },
    "domain": "executive_function",
    "skillId": "sorting_matching",
    "ageMin": 3,
    "free": true
  },
  {
    "id": "turtles-feeling-corner",
    "name": {
      "en": "Turtle's Feeling Corner",
      "ms": "Sudut Perasaan Penyu"
    },
    "domain": "social_emotional",
    "skillId": "emotional_recognition",
    "ageMin": 3,
    "free": true
  },
  {
    "id": "penguins-count-pool",
    "name": {
      "en": "Penguin's Count Pool",
      "ms": "Kolam Kira Penguin"
    },
    "domain": "numeracy",
    "skillId": "counting_cardinality",
    "ageMin": 3,
    "free": true
  },
  {
    "id": "zebras-color-stripes",
    "name": {
      "en": "Zebra's Color Stripes",
      "ms": "Jalur Warna Zebra"
    },
    "domain": "perception",
    "skillId": "colour_matching",
    "ageMin": 3,
    "free": false
  },
  {
    "id": "snakes-first-path",
    "name": {
      "en": "Snake's First Path",
      "ms": "Laluan Pertama Ular"
    },
    "domain": "motor",
    "skillId": "fine_motor_tracing",
    "ageMin": 3,
    "free": false
  },
  {
    "id": "koalas-morning",
    "name": {
      "en": "Koala's Morning",
      "ms": "Pagi Koala"
    },
    "domain": "daily_life",
    "skillId": "daily_routines",
    "ageMin": 3,
    "free": false
  },
  {
    "id": "elephants-3-step-task",
    "name": {
      "en": "Elephant's 3-Step Task",
      "ms": "Tugas Gajah"
    },
    "domain": "language",
    "skillId": "multi_step_instructions",
    "ageMin": 4,
    "free": false
  },
  {
    "id": "parrots-rhyme-race",
    "name": {
      "en": "Parrot's Rhyme Time",
      "ms": "Masa Berima Nuri"
    },
    "domain": "literacy",
    "skillId": "phonological_awareness",
    "ageMin": 4,
    "free": true
  },
  {
    "id": "lions-safe-choices",
    "name": {
      "en": "Lion's Safe Choices",
      "ms": "Pilihan Selamat Singa"
    },
    "domain": "daily_life",
    "skillId": "safety_awareness",
    "ageMin": 4,
    "free": false
  },
  {
    "id": "giraffes-spot-it",
    "name": {
      "en": "Giraffe's Spot-It",
      "ms": "Zirafah Cari-Cari"
    },
    "domain": "perception",
    "skillId": "visual_perception",
    "ageMin": 4,
    "free": false
  },
  {
    "id": "monkeys-memory-match",
    "name": {
      "en": "Monkey's Memory Match",
      "ms": "Permainan Ingatan Monyet"
    },
    "domain": "executive_function",
    "skillId": "working_memory",
    "ageMin": 4,
    "free": true
  },
  {
    "id": "penguins-turn",
    "name": {
      "en": "Penguin's Turn",
      "ms": "Giliran Penguin"
    },
    "domain": "social_emotional",
    "skillId": "turn_taking",
    "ageMin": 4,
    "free": true
  },
  {
    "id": "zebras-pattern-line",
    "name": {
      "en": "Zebra's Pattern Line",
      "ms": "Barisan Corak Zebra"
    },
    "domain": "executive_function",
    "skillId": "pattern_recognition",
    "ageMin": 4,
    "free": false
  },
  {
    "id": "turtles-calm-breath",
    "name": {
      "en": "Turtle's Calm Breath",
      "ms": "Nafas Tenang Penyu"
    },
    "domain": "social_emotional",
    "skillId": "emotional_regulation",
    "ageMin": 4,
    "free": true
  },
  {
    "id": "snakes-letter-path",
    "name": {
      "en": "Snake's Letter Path",
      "ms": "Laluan Huruf Ular"
    },
    "domain": "literacy",
    "skillId": "letter_formation",
    "ageMin": 4,
    "free": false
  },
  {
    "id": "parrots-sound-safari",
    "name": {
      "en": "Parrot's Sound Safari",
      "ms": "Safari Bunyi Nuri"
    },
    "domain": "literacy",
    "skillId": "phonics_letter_sounds",
    "ageMin": 5,
    "free": true
  }
];

/** Games that are places, not ladders: shown as visits, never as stages. */
export const CALM_GAMES: string[] = ["turtles-calm-breath"];
